import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";
import {MatIcon} from "@angular/material/icon";

import {ReactiveFormsModule} from "@angular/forms";

@Component({
    selector: 'app-vertical-sh-com-accessories',
    imports: [
    MatIcon,
    ReactiveFormsModule
],
    templateUrl: './vertical-sh-com-accessories.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './vertical-sh-com-accessories.component.css'
})
export class VerticalShComAccessoriesComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  replacementFilterSelection!: GuruEntity;
  stackKitsSelection!: GuruEntity;
  stackAccessoriesSelection!: GuruEntity;
  hoseKitsSelection!: GuruEntity;
  hoseKitAdapterSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.ACCESSORIES;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.replacementFilterSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFilter');
    this.stackKitsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USVerticalStackKit');
    this.stackAccessoriesSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USAccessories');
    this.hoseKitsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHoseKit');
    this.hoseKitAdapterSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHoseKitAdapter');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
